export const ApprovalType = {
  1: 'approvalType.drafted',
  2: 'approvalType.pendingForIM',
  3: 'approvalType.pendingForVX',
  4: 'approvalType.appproved',
  5: 'approvalType.rejected',
  6: 'approvalType.askForModifyFromIM',
  7: 'approvalType.askForModifyFromPM',
};
